import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Google as GoogleIcon } from "@mui/icons-material";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Login: React.FC = () => {
  const { signInWithGoogle, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Redirect authenticated users based on their status
  useEffect(() => {
    if (!authLoading && user) {
      console.log("Login User authenticated, redirecting...", { status: user.status, requestedRole: user.requestedRole });

      if (user.status === "approved") {
        // Approved users go to admin dashboard
        navigate("/admin", { replace: true });
      } else if (user.status === "pending" && user.requestedRole) {
        // User has registered, PrivateRoute will show StatusPage
        navigate("/admin", { replace: true });
      } else if (user.status === "pending" && !user.requestedRole) {
        // User needs to complete registration
        navigate("/register", { replace: true });
      } else if (user.status === "rejected") {
        // Rejected users, PrivateRoute will show StatusPage
        navigate("/admin", { replace: true });
      }
    }
  }, [user, authLoading, navigate]);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      await signInWithGoogle();
    } catch (err: any) {
      setError(err.message || "Failed to sign in with Google");
    } finally {
      setLoading(false);
    }
  };

  const logoUrl = "https://res.cloudinary.com/djbtf9won/image/upload/v1762320179/logox_aanwli.png";

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ padding: 4, width: "100%" }}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 2 }}>
            <Box
              component="img"
              src={logoUrl}
              alt="Logo"
              sx={{
                width: 120,
                height: "auto",
                objectFit: "contain",
                mb: 2,
              }}
            />
            <Typography component="h1" variant="h4" align="center" gutterBottom>
              News Platform
            </Typography>
          </Box>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 3 }}>
            Sign in to continue
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            fullWidth
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <GoogleIcon />}
            onClick={handleGoogleSignIn}
            disabled={loading}
            sx={{ mt: 1, mb: 2 }}
          >
            {loading ? "Signing in..." : "Sign in with Google"}
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default Login;

